import LazyLoad from 'vanilla-lazyload/dist/lazyload';
export default class LazyImages {
    static lazyLoad;
    static lazyLoadBackground;
    static init() {
        this.lazyLoad = new LazyLoad({
            elements_selector: '.lazy',
        });
        this.lazyLoadBackground = new LazyLoad({
            elements_selector: '.js__bg-image',
            callback_enter: (el) => {
                el.classList.add('loaded');
            },
        });
    }
    static update() {
        this.lazyLoad.update();
    }
    static updateBackground() {
        this.lazyLoadBackground.update();
    }
}
